import { pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

import { dggTheme } from '../../../../styles/dggTheme';

const { fonts } = dggTheme;

export const priceLabel = css`
  white-space: nowrap;
  font-family: ${fonts.PRIMARY_REGULAR.familyWithFallbacks};
`;

export const preSalePrice = css`
  margin: 0 ${pxToRem(4)};
  text-decoration: line-through;
`;

export const price = css`
  margin: 0 ${pxToRem(4)};
  font-family: ${fonts.PRIMARY_SEMIBOLD.familyWithFallbacks};
`;
